import React from "react";
import Layout from "components/layout";
import { GlobalState, UserState } from "utils/types";
import { compose } from "redux";
import { connect } from "react-redux";
import { Typography, Theme, makeStyles } from "@material-ui/core";

interface Props {
  userState: UserState
}

const useStyles = makeStyles((theme: Theme) => ({
  topBar: {
    minHeight: "110px",
    marginBottom: theme.spacing(2),
    background: "#ffffff",
    padding: theme.spacing(3, 8)
  }
}));


function Profile(props: Props) {
  const classes = useStyles()
  // isolate role from permissions
  const roleString = props.userState.me.permissions.find(role => role.includes("role"))
  // set display string for user role
  let roleDisplay
  switch (roleString) {
    case "admin-app:role-adjuster":
      roleDisplay = "Adjuster"
      break
    case "admin-app:role-supervisor":
      roleDisplay = "Supervisor"
      break
    case "admin-app:role-admin":
      roleDisplay = "Admin"
      break
    case "admin-app:role-support":
      roleDisplay = "Support"
      break
    case undefined:
      roleDisplay = "No Assigned Role"
      break
  }
  return <Layout page="profile">
    <div className={classes.topBar}>
    <Typography variant="h4">
    {props.userState.me.displayName}
      </Typography>
      <Typography variant="h5">
        {props.userState.me.email}
      </Typography>
      <Typography variant="h5">
        {roleDisplay}
      </Typography>
    </div>
  </Layout>;
}

const mapStateToProps = (state: GlobalState) => ({
  userState: state.user
})

export default compose(connect(mapStateToProps, null))(Profile)